import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, bool_type, list_type, enum_type, class_type, union_type, string_type, option_type, int32_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { File_AdminFileListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Paginated$1_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { Remote$1, Remote$1_$reflection, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";

export class Page extends Union {
    constructor(page, kundennummer, kategorie) {
        super();
        this.tag = 0;
        this.fields = [page, kundennummer, kategorie];
    }
    cases() {
        return ["List"];
    }
}

export function Page_$reflection() {
    return union_type("AdminFile.Types.Page", [], Page, () => [[["page", int32_type], ["kundennummer", option_type(int32_type)], ["kategorie", option_type(string_type)]]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadList", "ListLoaded", "KundennummernFilterTextChanged", "FilterForKundennummerClear", "FilterForKundennummer", "FilterForKategorie", "ActivateFile", "DeactivateFile", "ActiveChanged", "LoadAllKundennummern", "AllKundennummernLoaded", "LoadAllKategorien", "AllKategorienLoaded", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("AdminFile.Types.Msg", [], Msg, () => [[["page", int32_type], ["kundennummer", option_type(int32_type)], ["kategorie", option_type(string_type)]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Paginated$1_$reflection(File_AdminFileListItem_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Paginated$1_$reflection(File_AdminFileListItem_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", string_type]], [], [], [["Item", option_type(string_type)]], [["id", string_type], ["filetype", enum_type("Bfs.Web.Data.Service.Contracts.Kundenportal.File.FileType", int32_type, [["Csv", 1], ["Pdf", 2], ["File", 3]])]], [["id", string_type], ["filetype", enum_type("Bfs.Web.Data.Service.Contracts.Kundenportal.File.FileType", int32_type, [["Csv", 1], ["Pdf", 2], ["File", 3]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(int32_type), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(int32_type)]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(string_type), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(string_type)]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", GlobalMsg_$reflection()]]]);
}

export class Model extends Record {
    constructor(PageNumber, Kundennummer, Kategorie, Files, AllKategorien, AllKundennummern, KundennummernFilterText, KundennummernFilterEnabeld) {
        super();
        this.PageNumber = (PageNumber | 0);
        this.Kundennummer = Kundennummer;
        this.Kategorie = Kategorie;
        this.Files = Files;
        this.AllKategorien = AllKategorien;
        this.AllKundennummern = AllKundennummern;
        this.KundennummernFilterText = KundennummernFilterText;
        this.KundennummernFilterEnabeld = KundennummernFilterEnabeld;
    }
}

export function Model_$reflection() {
    return record_type("AdminFile.Types.Model", [], Model, () => [["PageNumber", int32_type], ["Kundennummer", option_type(int32_type)], ["Kategorie", option_type(string_type)], ["Files", Remote$1_$reflection(Paginated$1_$reflection(File_AdminFileListItem_$reflection()))], ["AllKategorien", list_type(string_type)], ["AllKundennummern", list_type(int32_type)], ["KundennummernFilterText", string_type], ["KundennummernFilterEnabeld", bool_type]]);
}

export function Model_Init(pagenumber, kundennummer, kategorie, allKundennummern, allKategorien) {
    return new Model(pagenumber, kundennummer, kategorie, new Remote$1(1, []), allKategorien, allKundennummern, "", false);
}

//# sourceMappingURL=Types.fs.js.map
